import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ShowMissingDocuments from './ShowMissingDocuments';
import MissingParts from './MissingParts';

const MissingPartsRouter = () => {
  return (
    <Routes>
      <Route index element={<MissingParts />} />
      <Route path="show/:id" element={<ShowMissingDocuments />} />
    </Routes>
  );
};

export default MissingPartsRouter;
